<template>
  <div class="modal-form">
    <b-modal :id="id" :size="size" hide-footer centered>
      <div class="col-12 d-flex flex-column align-items-center">
        <img
          v-if="status === 'success'"
          class="centerImg1"
          src="@/assets/images/icons/checkbox-circle-line.svg"
        />

        <img
          v-if="status === 'danger'"
          class="centerImg1"
          src="@/assets/images/icons/close-circle-line.svg"
          width="20%"
        />
        <div class="title-modal-confirm font-weight-bold mt-4 mb-2">
          {{ title }}
        </div>
        <div class="content-modal-info my-3 text-center" v-html="content"></div>
        <slot></slot>
        <div class="mt-2 d-flex">
          <OkayModal @click="$emit('entendido')"> Entendido </OkayModal>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import OkayModal from "@/components/core/button/okay-modal.vue";
export default {
  name: "info-modal",
  components: { OkayModal },
  props: {
    id: {
      default: "",
      type: String,
    },
    size: {
      default: "",
      type: String,
    },
    status: {
      default: "",
      typeo: String,
    },
    title: {
      default: "",
      type: String,
    },
    content: {
      default: "",
      type: String,
    },
  },
  emits: ["entendido"],
  data() {
    return {};
  },
  beforeMount() {},
  methods: {},
};
</script>
<style lang="scss">
.title-modal-confirm {
  font-weight: 500;
  font-size: 21px;
  line-height: 24px;

  text-align: center;

  color: #263238 !important;
}

.content-modal-info {
  font-family: "Ubuntu";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 28px;
  color: #455a64;
}

.modal-header .close {
  font-weight: 500;
  font-size: 32px;
  text-transform: uppercase;
  color: blue;
}

.img-warning-modal {
  width: auto;
  height: auto;
}
</style>